var _excluded = ["children", "className", "id"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import classnames from 'classnames';
import StyledSupportiveText from "./styled";
import Text from "../Text";
import { FIELD_SUPPORTIVE } from "../../constants";
var SupportiveText = function SupportiveText(_ref) {
  var children = _ref.children,
    className = _ref.className,
    id = _ref.id,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, Boolean(children) && /*#__PURE__*/React.createElement(StyledSupportiveText, _extends({}, rest, {
    className: classnames('csl-supportive-text', className),
    "data-csl-selector": FIELD_SUPPORTIVE
  }), /*#__PURE__*/React.createElement(Text, {
    size: "s2"
  }, children)));
};
SupportiveText.displayName = 'SupportiveText';
export default SupportiveText;